import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { InfoIcon } from '../../pages/PerformancePage';

const ImpactCard = ({ title = "", subtitle = "", roi = '6.87 x', tooltip = 'Return on Investment', accentColor = '#000000', pending = false }) => {
  return (
    <div className='col-lg-6 col-md-12 mb-4 mb-lg-0'>
      <div className='main-impact-card '>
        <Card className="impact-card p-0 h-100">
          <Row className="g-0 h-100 align-items-center position-relative ">
            <div className='info-icon'>
              <InfoIcon tooltip={tooltip} tipId={"info-icon"}/>
            </div>

            <Col xs="auto" className='h-100'>
              <div className="left-bar" style={{ background: `linear-gradient(180deg, ${accentColor} 1.2%, rgba(233, 227, 255, 0) 100%)` }} />
            </Col>

            <Col className='ps-0'>
              <Card.Body className="p-0">


                <Row className="align-items-center">
                  <div className='col-sm-9 main-label-text'>
                    <span className="label-text">
                      {title}
                    </span>
                    {subtitle && <p className="impact-card-subtitle">{subtitle}</p>}
                  </div>
                  <div className="text-end col-sm-3 main-value-text" >
                    {pending ? (
                      <span className="impact-card-pending">Available after event concludes</span>
                    ) : (
                      <span className="value-text">{roi.toLocaleString()}x</span>
                    )}
                  </div>
                </Row>
              </Card.Body>
            </Col>
          </Row>
        </Card>
      </div>
    </div>
  );
};

export default ImpactCard;